// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610220839/js/" + chunkId + "." + {"44":"79e1289e","225":"f342d9dc","481":"26d622de","486":"7cbc8178","770":"e6492126"}[chunkId] + ".0.3094282428977738.chunk.js";
};